import React, { useState } from "react";
import { isLoginHSProduct } from "../config/product";

// ──────────────────────────────────────────────────────
// ContactPage.jsx — 공개 문의하기 (로그인 불필요)
//   푸터/랜딩 '문의하기' → /?page=contact. POST /api/inquiry/public.
//   톤 = LoginHS 절제(검정·회색). SNS 앱 승인용 공개 연락 창구.
// ──────────────────────────────────────────────────────

const INK = "#16151a";
const DARK = "#1b1a20";
const LINE = "#e5e7eb";
const MUTED = "#6b7280";

const ContactPage = ({ API_BASE_URL, onNavigate }) => {
  const BRAND = isLoginHSProduct() ? "LoginHS" : "DocuAI";
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const goHome = () => {
    window.history.replaceState({}, "", "/");
    if (onNavigate) onNavigate("landing");
    else window.location.href = "/";
  };

  const submit = async () => {
    setError("");
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email))
      return setError("이메일을 정확히 입력해주세요.");
    if (message.trim().length < 5) return setError("문의 내용을 입력해주세요.");
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/inquiry/public`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message }),
      });
      const data = await res.json();
      if (data.success) setDone(true);
      else {
        setError(data.message || "문의 접수에 실패했습니다.");
        setLoading(false);
      }
    } catch (e) {
      setError("문의 접수 중 오류가 발생했습니다.");
      setLoading(false);
    }
  };

  const input = {
    width: "100%",
    boxSizing: "border-box",
    padding: "11px 13px",
    fontSize: 14,
    border: `1px solid ${LINE}`,
    borderRadius: 9,
    outline: "none",
    fontFamily: "inherit",
  };
  const labelS = {
    fontSize: 13,
    fontWeight: 700,
    color: INK,
    margin: "0 0 6px",
    display: "block",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f8fafc 0%, #eef0f4 100%)",
        padding: 16,
        fontFamily:
          "'Malgun Gothic', '맑은 고딕', 'Pretendard Variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 460,
          background: "#fff",
          border: `1px solid ${LINE}`,
          borderRadius: 16,
          padding: "32px 28px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.06)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 22 }}>
          <div style={{ fontSize: 20, fontWeight: 800, color: INK }}>
            문의하기
          </div>
          <p style={{ fontSize: 13, color: MUTED, margin: "8px 0 0" }}>
            {BRAND} 서비스 관련 문의를 남겨주시면 확인 후 답변드립니다.
          </p>
        </div>

        {done ? (
          <div style={{ textAlign: "center", padding: "12px 0" }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: INK }}>
              문의가 접수되었습니다 
            </div>
            <p style={{ fontSize: 13, color: MUTED, margin: "10px 0 20px" }}>
              남겨주신 이메일로 답변드리겠습니다. 감사합니다.
            </p>
            <button onClick={goHome} style={primaryBtn()}>
              홈으로
            </button>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: 14 }}>
              <label style={labelS}>이름 (선택)</label>
              <input
                style={input}
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="이름 또는 회사명"
                maxLength={60}
              />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={labelS}>이메일</label>
              <input
                style={input}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="답변받을 이메일"
                maxLength={120}
              />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={labelS}>문의 내용</label>
              <textarea
                style={{ ...input, minHeight: 120, resize: "vertical" }}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="문의하실 내용을 입력해주세요."
                maxLength={4000}
              />
            </div>

            {error && (
              <div
                style={{
                  fontSize: 13,
                  color: "#d93025",
                  marginBottom: 12,
                  textAlign: "center",
                }}
              >
                {error}
              </div>
            )}

            <button
              onClick={submit}
              disabled={loading}
              style={{
                ...primaryBtn(),
                opacity: loading ? 0.6 : 1,
                cursor: loading ? "default" : "pointer",
              }}
            >
              {loading ? "전송 중…" : "문의 보내기"}
            </button>

            <div
              style={{
                marginTop: 18,
                paddingTop: 14,
                borderTop: `1px solid ${LINE}`,
                fontSize: 12.5,
                color: MUTED,
                textAlign: "center",
                lineHeight: 1.7,
              }}
            >
              이메일{" "}
              <a href="mailto:jmkim@logins.kr" style={{ color: "#4b5563" }}>
                jmkim@logins.kr
              </a>{" "}
              · 전화 032-744-6000
            </div>

            <button
              onClick={goHome}
              style={{
                width: "100%",
                marginTop: 10,
                background: "transparent",
                border: "none",
                color: MUTED,
                fontSize: 13,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              홈으로
            </button>
          </>
        )}
      </div>
    </div>
  );
};

function primaryBtn() {
  return {
    width: "100%",
    padding: "13px 0",
    background: DARK,
    color: "#fff",
    border: "none",
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 700,
    cursor: "pointer",
    fontFamily: "inherit",
  };
}

export default ContactPage;
